const translations = {};

try {
    const translationContext = require.context('./localazy', true, /\.json$/);

    for (const key of translationContext.keys()) {
        const lang = key.split('/')[1];
        translations[lang] = translationContext(key)[lang];
    }
} catch (error) {
    translations.error = true;
}

export default translations;
